import { reactive } from 'vue'

export const globalLoading = reactive({
  count: 0,
  get active() {
    return this.count > 0
  },
})
